import { getCoreConfig } from '../config/config';

function getClientId(): string {
  try {
    const stored = localStorage.getItem('ga_client_id');
    if (stored) return stored;
    const id = crypto.randomUUID();
    localStorage.setItem('ga_client_id', id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

function sanitizeEventName(name: string) {
  return name
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_]/g, '')
    .substring(0, 40);
}

export function sendGAEvent(eventName: string, params: Record<string, unknown>): void {
  const { googleAnalyticsMeasurementId, googleAnalyticsApiKey } = getCoreConfig();
  if (!googleAnalyticsMeasurementId || !googleAnalyticsApiKey) return;
  fetch(
    `https://www.google-analytics.com/mp/collect?measurement_id=${googleAnalyticsMeasurementId}&api_secret=${googleAnalyticsApiKey}`,
    {
      method: 'POST',
      body: JSON.stringify({
        client_id: getClientId(),
        events: [{ name: sanitizeEventName(eventName), params: { engagement_time_msec: 100, ...params } }],
      }),
    },
  );
}
